(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("quill"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["quill", "vue"], factory);
	else if(typeof exports === 'object')
		exports["vue3-quill"] = factory(require("quill"), require("vue"));
	else
		root["vue3-quill"] = factory(root["Quill"], root["vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__6c81__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 